module.exports = __webpack_public_path__ + "static/media/Valentino ad campaign.db720c39.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/Valentino ad campaign.jpeg
// module id = 149
// module chunks = 0